import { derived, writable, Writable } from "svelte/store";

export const selectCompanionSceneVisibleStore = writable(false);
